export default __webpack_public_path__ + "static/brand-image-2cc58a68c1094ec240ccd316909749f6.jpg";